import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export const GhostButton = ({ children, href, onClick, className = '', external = false, ...props }) => {
  const classes = `
    inline-flex items-center gap-2
    border border-white/[0.12] bg-white/[0.04]
    text-white/80 font-medium px-7 py-3.5 rounded-xl
    backdrop-blur-md
    transition-all duration-300
    hover:bg-white/[0.08] hover:text-white hover:border-white/[0.2]
    ${className}
  `;

  const motionProps = {
    whileHover: { scale: 1.03 },
    whileTap: { scale: 0.97 },
  };

  if (external) {
    return (
      <motion.div {...motionProps}>
        <a href={href} target="_blank" rel="noopener noreferrer" className={classes} data-testid={props['data-testid']}>
          {children}
        </a>
      </motion.div>
    );
  }

  if (href) {
    return (
      <motion.div {...motionProps}>
        <Link to={href} className={classes} data-testid={props['data-testid']}>
          {children}
        </Link>
      </motion.div>
    );
  }

  return (
    <motion.button className={classes} onClick={onClick} {...motionProps} {...props}>
      {children}
    </motion.button>
  );
};
